module.exports = __webpack_public_path__ + "static/media/_MIC2412.image.7ba97784.png";